import { apiResolverApi } from "@gymflow/api";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { OptionType } from "./components/OptionsList/components/OptionItem";
import { SearchInput, SearchInputProps } from "./SearchInput";

export type LocationsSearchInputOptionType = OptionType<{
  id: string;
  name: string;
}>;
export type LocationsSearchInputOptionsType = LocationsSearchInputOptionType[];

export type LocationsSearchInputProps = Pick<
  SearchInputProps<{ id: string; name: string }>,
  "label" | "value" | "onChange" | "dropPosition" | "isMulti" | "className"
>;

const SEARCH_LIST_SIZE = 10;

export const LocationsSearchInput = (props: LocationsSearchInputProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { brand } = usePortalRoutes();
  const { t } = useTranslation();

  return (
    <SearchInput<{ id: string; name: string }>
      {...props}
      dataFetchingQuery={(searchTermLocal) => {
        return infiniteQueryOptions({
          queryKey: [
            "locations-search",
            brand,
            searchTermLocal,
            SEARCH_LIST_SIZE,
          ] as QueryKey,
          queryFn: async () => {
            setSearchTerm(searchTermLocal);

            const { results } = await apiResolverApi.findRoutes({
              brand,
              page: 0,
              limit: SEARCH_LIST_SIZE,
            });
            const mappedResults: LocationsSearchInputOptionType[] = results
              .filter((r) =>
                r.displayName
                  .toLowerCase()
                  .includes(searchTermLocal.toLowerCase()),
              )
              .map((location) => ({
                id: location.clubId.toString(),
                label: location.displayName,
                value: {
                  id: location.clubId.toString(),
                  name: location.displayName,
                },
              }))
              .filter(
                (option, index, self) =>
                  index === self.findIndex((o) => o.id === option.id),
              );
            return mappedResults;
          },
          initialPageParam: 0,
          getNextPageParam: () => undefined,
          enabled: Boolean(searchTermLocal.trim()),
        });
      }}
      notFoundClassName="justify-start"
      notFound={
        !searchTerm.trim() &&
        t("page.settings.tab.staff.addStaff.form.locationSearchBar")
      }
      withImageByDefault={false}
      selectedOptionClassName="rounded-full"
    />
  );
};
